import {
	SET_EVENT,
	LOAD_MEETINGS_EVENTS_LEGACY_PRODUCER,
	LOAD_MEETINGS_SHOWROOMS_PRODUCER,
	LOAD_MEETINGS_PRESENTER,
	SET_LIVE_CHANNELS,
	UPDATE_EVENTS_PRESENTER,
	LOAD_MEETINGS_STANDALONE_GREENROOM_PRODUCER,
	LOAD_MEETINGS_EVENTS_PRODUCER,
	GET_DEFAULT_BACKGROUNDS
} from '../actions/content';
import { handle } from 'redux-pack';

export interface MediaBackground {
	image: string;
	thumb: string;
}

export interface ContentState {
	event: any;
	isLoadingEvent: boolean;
	eventError: boolean;
	loadedEvent: any;
	events: any[];
	loadingEvents: boolean;
	eventsError: string | null;
	meetings: any[];
	loadingMeetings: boolean;
	meetingsError: string | null;
	liveChannels: number[];
	defaultBackgrounds: MediaBackground[];
}

const initialState: ContentState = {
	event: {},
	isLoadingEvent: false,
	eventError: false,
	loadedEvent: {},
	events: [],
	loadingEvents: true,
	eventsError: null,
	meetings: [],
	loadingMeetings: false,
	meetingsError: null,
	liveChannels: [],
	defaultBackgrounds: []
};

interface Action {
	type: string;
	payload: any;
}

const actions: Map<any, Function> = new Map([
	[SET_EVENT, (state: ContentState, action: Action) => ({ ...state, event: action.payload })],
	[LOAD_MEETINGS_EVENTS_PRODUCER, (state: ContentState, action: Action) => handle(state, action, {
		start: state => ({
			...state,
			loadingEvents: true,
			eventsError: null
		}),
		finish: state => ({ ...state, loadingEvents: false }),
		failure: state => ({ ...state, eventsError: action.payload }),
		success: state => {
			const newState = { ...state }
			newState.events = action.payload;
			return newState;
		}
	})],
	[LOAD_MEETINGS_EVENTS_LEGACY_PRODUCER, (state: ContentState, action: Action) => handle(state, action, {
		start: state => ({
			...state,
			loadingEvents: true,
			eventsError: null
		}),
		finish: state => ({ ...state, loadingEvents: false }),
		failure: state => ({ ...state, eventsError: action.payload }),
		success: state => {
			const newState = { ...state }
			newState.events = action.payload;
			return newState;
		}
	})],
	[LOAD_MEETINGS_SHOWROOMS_PRODUCER, (state: ContentState, action: Action) => handle(state, action, {
		start: state => ({
			...state,
			loadingEvents: true,
			eventsError: null
		}),
		finish: state => ({ ...state, loadingEvents: false }),
		failure: state => ({ ...state, eventsError: action.payload }),
		success: state => {
			const newState = { ...state }
			newState.events = action.payload;
			return newState;
		}
	})],
	[LOAD_MEETINGS_STANDALONE_GREENROOM_PRODUCER, (state: ContentState, action: Action) => handle(state, action, {
		start: state => ({
			...state,
			loadingEvents: true,
			eventsError: null
		}),
		finish: state => ({ ...state, loadingEvents: false }),
		failure: state => ({ ...state, eventsError: action.payload }),
		success: state => {
			const newState = { ...state }
			newState.events = action.payload;
			return newState;
		}
	})],
	[LOAD_MEETINGS_PRESENTER, (state: ContentState, action: Action) => handle(state, action, {
		start: state => ({
			...state,
			loadingEvents: true,
			eventsError: null
		}),
		finish: state => ({ ...state, loadingEvents: false }),
		failure: state => ({ ...state, eventsError: action.payload }),
		success: state => {
			const newState = { ...state }
			newState.events = action.payload;
			return newState;
		}
	})],
	[SET_LIVE_CHANNELS, (state: ContentState, action: Action) => ({ ...state, liveChannels: action.payload })],
	[UPDATE_EVENTS_PRESENTER, (state: ContentState, action: Action) => ({ ...state, events: action.payload })],
	[GET_DEFAULT_BACKGROUNDS, (state: ContentState, action: Action) => ({ ...state, defaultBackgrounds: action.payload })]
]);

export function ContentReducer(state: ContentState = initialState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}